<template>
  <div class="h-100" :style="isOwl ? { marginTop: '5px' } : { margin: '5px' }">
    <div v-if="itemLayout == 'horizontal'">開發中...</div>
    <div v-else class="border h-100" :class="promotion?.page?.name ? 'promotion-single-hover-' : 'rounded'" >
      <div
        class="inline_product clickable d-flex justify-content-center"
        style="cursor: pointer; background: var(--primary_color) 10;background-position: center center; background-size: cover;"
      >
        <!-- <div class="d-flex top-tag" style="position: absolute; z-index: 1" :style="gutterStyle" v-if="promotion.discount_type != 'non'">
          <span class="for-discoutn-value p-1 pl-2 pr-2">
            <span v-if="promotion.condition_min_type == 'amount'">
              {{ t("promotions.conditionAmount") }}
            </span>
            <span v-else-if="promotion.condition_min_type == 'qty'">
              {{ t("promotions.conditionQty") }}
            </span>
            <span v-if="promotion.discount_type == 'amount'">
              {{ t("promotions.discountTypeAmount") }}
            </span>
            <span v-else-if="promotion.discount_type == 'percentage'">
              {{ t("promotions.discountTypePercentage") }}
            </span>
          </span>
        </div> -->

        <div class="d-flex center-div element-center" :style="imageStyle">
          <a :href="promotion.is_open_group?`/promotion-groups/${ promotion.id }`:`/promotions/${ promotion.id }`" class="w-100">
            <RatioImage 
              :src="imgProxy(promotion.banner_media?.url, rs='fill:300:300:1')" 
              :ratio="IMAGE_RATIO" 
              :tip="dt(promotion.title_translations, locale)"
            />
          </a>
        </div>
      </div>

      <div class="single-promotion-details position-relative p-2 border-top text-center" :style="contentStyle">
        <label v-if="isComing" class="rounded bg-info text-white px-2 py-1 mb-1 w-100">
          <date-countdown-single :start-date="promotion.start_at" :end-date="promotion.ended_at" text-class="text-white" />
        </label>
        <label v-else-if="isEnded" class="rounded bg-secondary text-white px-2 py-1 mb-1 w-100">
          <date-countdown-single :start-date="promotion.start_at" :end-date="promotion.ended_at" text-class="text-muted" />
        </label>
        <label v-else-if="promotion.ended_at" class="rounded bg-primary text-white px-2 py-1 mb-1 w-100">
          <date-countdown-single :start-date="promotion.start_at" :end-date="promotion.ended_at" text-class="text-white" />
        </label>

        <div class="font-weight-bold text-truncate-3">
          <a :href="promotion.is_open_group?`/promotion-groups/${ promotion.id }`:`/promotions/${ promotion.id }`">
            {{ dt(promotion.title_translations, locale) }}
          </a>
        </div>
        <span v-if="!hiddenPrice && promotion?.price_range" class="text-accent">
          {{ priceRange(promotion.price_range, "discounted_price") }}
        </span>
        <div v-if="displayCoinReward" class="text-warning">
          <img src="/static/images/coin.png" style="max-height: 30px" alt="owner_coin_reward" />
          {{ priceRange(promotion.price_range, "owner_coin_reward", "", true) }}
        </div>
      </div>

      <div v-if="promotion?.page?.id" class="text-center quick-view- pt-2">
        <el-button type="primary" @click="onClickView" hidden>
          <i class="czi-eye align-middle mr-1"></i>
          {{ t("global.quickView") }}
        </el-button>

        <div class="justify-content-between text-center px-3 pb-2">
          <a :href="`/fanspage/${ promotion.page.id }`">
            <div class="media media-ie-fix">
              <RatioImage 
                v-if="promotion?.page?.picture" 
                ratio="1:1" 
                :src="promotion.page.picture" 
                :tip="promotion.page.name"
                class="rounded-circle overflow-hidden mr-1" 
                style="max-width: 27px;" 
              />
              <span v-if="promotion?.page?.name" class="text-truncate-2 text-accent">
                {{ promotion.page.name }}
              </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { dataTranslations as dt, priceRange, imgProxy, lookupAliasTranslations } from "../../utils"
import DateCountdownSingle from "./DateCountdownSingle.vue"
import RatioImage from '../RatioImage.vue'

const props = defineProps({
  promotion: Object,
  isOwl: Boolean,
  storeData: Object,
  itemLayout: { type: String, default: "vertical" },
})
const emit = defineEmits(['view'])

const { t, n, locale } = useI18n()

const hiddenPrice = computed(() => !!props.storeData?.settings?.hidden_price)
const hiddenCart = computed(() => !!props.storeData?.settings?.hidden_cart)
const hiddenContact = computed(() => !!props.storeData?.settings?.hidden_contact)
const aliasTranslations = computed(() => lookupAliasTranslations(props.storeData?.alias_translations, locale.value))

const isComing = computed(() => props.promotion.start_at ? dayjs(props.promotion.start_at) > dayjs() : false)
const isEnded = computed(() => props.promotion.ended_at ? dayjs(props.promotion.ended_at) < dayjs() : false)
const displayCoinReward = computed(() => props.promotion?.display_coin_reward && props.promotion?.price_range?.min_owner_coin_reward > 0)
const gutterStyle = computed(() => props.isOwl ? { left: '5px', top: '5px' } : { left: '13px', top: '13px' })

const dialogVisible = ref(false)
const IMAGE_RATIO = "1:1"

const onClickView = () => {
  emit("view", props.promotion)
}
const contentStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
			borderRadius: '0px 5px 5px 0px',
		}
	}
	return {
		// height: displayCoinReward.value ? '160px' : '130px',
		paddingTop: '10px',
		borderRadius: '0px 0px 5px 5px',
	}
})
const imageStyle = computed(() => {
	if (props.itemLayout == "horizontal") {
		return {
      cursor: 'pointer',
			borderRadius: '5px 0px 0px 5px',
		}
	}
	return {
    cursor: 'pointer',
		borderRadius: '5px 5px 0px 0px',
	}
})
</script>

<style scoped>
</style>